export enum NiloPermissions {
  NILO_AGREEMENT_EDIT,
  NILO_AGREEMENT_READ,
  NILO_FAMILIA,
  NILO_FERIADO,
  NILO_BILLING_EDIT,
  NILO_BILLING_READ,
  NILO_BILLING_INCIDENCES_USER,
  NILO_BILLING_INCIDENCES_MANAGER,
  NILO_INTEGRATION_CONTROL_READ,
  NILO_GEOGRAPHIES_EDIT,
  NILO_INTEGRATION_CONTROL_EDIT,
  NILO_PRODUCT_EDIT,
  NILO_PRODUCT_READ,
  NILO_BILLING_CLOSURE_CONTROL,
  NILO_CUSTOMER_EDIT,
  NILO_CUSTOMER_READ,
  NILO_SECURITY_USER_EDIT,
  NILO_SECURITY_USER_READ,
  NILO_SECURITY_ROLE_EDIT,
  NILO_SECURITY_ROLE_READ,
  NILO_LOCATION_EDIT,
  NILO_LOCATION_READ,
  NILO_LOCATION_REVIEW,
  NILO_ADMIN,
  NILO_ENTITY_EDIT,
  NILO_ENTITY_READ,
}
